import Vue from 'vue'
import App from './App.vue'
import router from './router'

import { registerVueGlobalComponent } from '@/register/vue-global-component.register';
import '@/assets/fonts/all.min.css';

import Carousel from 'vue-carousel';
import Vuelidate from 'vuelidate'

Vue.use(Carousel);
Vue.use(Vuelidate as any);

Vue.config.productionTip = false

registerVueGlobalComponent(Vue);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
